<template>
  <v-content>
    <v-container fluid fill-height dark>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <LoginForm v-if="!is_reset_mode" />
          <ResetPasswordForm
            v-if="is_reset_mode"
            :login="username"
            :forced="is_forced_reset"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import router from '@/router';
import store from '../store';
import Cookies from 'js-cookie';
import { makeBasicAuthToken } from '@/services/auth';
import { notifyError } from '@/services/notifications';
import LoginForm from '@/components/Forms/LoginForm';
import ResetPasswordForm from '@/components/Forms/ResetPasswordForm';

export default {
  name: 'Login',
  components: { ResetPasswordForm, LoginForm },
  data() {
    return {
      valid: false,
      passwordRules: [(v) => !!v || 'Password Required'],

      alert: false,
      alertMessage: 'Default String',

      login: '',
      password: '',

      loginRules: [(v) => !!v || 'Login Required'],
      type: 'password',
      apiUri: 'http://192.168.1.231/api',

      previousPassword: '',
      resetPassword: '',
      resetPasswordConfirm: '',
    };
  },
  computed: {
    username() {
      const login = this.$route.query.login;
      if (login) {
        return login;
      }

      return '';
    },
    is_reset_mode() {
      const mode = this.$route.query.mode;
      if (mode) {
        return mode === 'reset';
      }

      return false;
    },
    is_forced_reset() {
      const forced = this.$route.query.forced;
      if (forced !== undefined && forced !== null) {
        return forced === 'true' || forced === true;
      }

      return false;
    },
  },
  methods: {
    async onLogin(reseted = false) {
      store.commit('resetAuthToken');
      if (!this.$refs.form.validate()) {
        return;
      }
      let token = {};

      if (reseted) {
        token = makeBasicAuthToken(this.username, this.resetPassword);
      } else {
        token = makeBasicAuthToken(this.login, this.password);
      }

      try {
        const response = await this.$axios.login.get({
          headers: { Authorization: token },
        });

        if (response.status == 200) {
          Cookies.set('authToken', token);
          store.commit('setAuthToken', token);
          const userRights = response.data.rights;
          const username = response.data.name;
          store.commit('setUsername', username);
          store.commit('setCurrentUserRights', userRights);
          router.push({ path: '/cards' });
        }
      } catch (error) {
        console.error(error);

        if (error.response.status === 401) {
          const errorType = error.response.data.errorType;
          switch (errorType) {
          case 'WRONG_PASSWORD': {
            notifyError('', this.$t('loginForm.wrongPassword'));
            break;
          }
          case 'BLOCKED': {
            notifyError('', this.$t('loginForm.blocked'));
            break;
          }
          case 'NEED_RESET_PASSWORD': {
            notifyError('', this.$t('loginForm.needResetPassword'));
            store.commit('setUsername', this.login);
            this.$store.commit('setResetPassword');

            break;
          }
          case 'NO_RIGHTS': {
            notifyError('', this.$t('loginForm.noRights'));
            break;
          }
          }
        }
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
</style>
